// src/i18n.ts
import i18next from "i18next";
import { format } from "date-fns/format";

// src/utils/escapeTextForBrowser.ts
var matchHtmlRegExp = /["'&<>]/;
function escapeHtml(value) {
  const str = String(value);
  const match = matchHtmlRegExp.exec(str);
  if (!match) {
    return str;
  }
  let escape2;
  let html = "";
  let index;
  let lastIndex = 0;
  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        escape2 = "&quot;";
        break;
      case 38:
        escape2 = "&amp;";
        break;
      case 39:
        escape2 = "&#x27;";
        break;
      case 60:
        escape2 = "&lt;";
        break;
      case 62:
        escape2 = "&gt;";
        break;
      default:
        continue;
    }
    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }
    lastIndex = index + 1;
    html += escape2;
  }
  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
function escapeTextForBrowser(text) {
  if (typeof text === "boolean" || typeof text === "number") {
    return "" + text;
  }
  return escapeHtml(text);
}
var escapeTextForBrowser_default = escapeTextForBrowser;

// src/nestedLinksParserPlugin.ts
var nestedLinksParserPlugin = {
  type: "postProcessor",
  name: "nestedLinksParser",
  process: function(value, _key, options) {
    const linksBlank = options.linksBlank;
    const links = options?.links;
    const classNameAttr = options?.classNameAttr ? ` className="${options?.classNameAttr}"` : "";
    const classAttr = options?.classAttr ? ` class="${options?.classAttr}"` : "";
    let matchIndex = 0;
    return value.replace(/<a>/g, () => {
      const subStitute = `<a${classNameAttr}${classAttr}${linksBlank?.[matchIndex] ? ' target="_blank"' : ""} href="${links?.[matchIndex] || ""}">`;
      matchIndex++;
      return subStitute;
    });
  }
};

// src/i18n.ts
var DEFAULT_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
var init = ({
  lng,
  translation = {},
  translations = {},
  dateLocale,
  enableNestedLinksPlugin = false
}) => {
  const translationResources = {
    translation,
    ...translations
  };
  const newInstance = i18next.createInstance();
  const initObject = {
    lng,
    resources: {
      [lng]: translationResources
    },
    interpolation: {
      escapeValue: false,
      // not needed for React!!
      formatSeparator: ","
    },
    // key potentially can contain untrusted HTML which should be escaped if translation is not found
    parseMissingKeyHandler: (key, defaultValue) => defaultValue || escapeTextForBrowser_default(key)
  };
  if (enableNestedLinksPlugin) {
    initObject.postProcess = "nestedLinksParser";
    void newInstance.use(nestedLinksParserPlugin).init(initObject);
  } else {
    void newInstance.init(initObject);
  }
  return {
    t: newInstance.t.bind(newInstance),
    tExists: newInstance.exists.bind(newInstance),
    date: (date, formatString = DEFAULT_FORMAT) => format(date, formatString, { locale: dateLocale })
  };
};
var i18n_default = {
  init
};

// src/Trans.tsx
import React2 from "react";

// src/I18nContext.tsx
import React, { useContext } from "react";
var I18nContext = React.createContext(void 0);
var useI18nContext = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("I18nContext should be wrapped with <I18nContextProvider>");
  }
  return context;
};
var I18nContextProvider = ({
  i18nInstance,
  children
}) => /* @__PURE__ */ React.createElement(I18nContext.Provider, { value: i18nInstance }, children);

// src/Trans.tsx
var SafeString = class {
  value;
  constructor(value) {
    this.value = value;
  }
  toString() {
    return this.value == null ? "" : this.value;
  }
  toHtml() {
    return this.toString();
  }
};
function isSafeString(str) {
  return str?.toHtml !== void 0;
}
function escape(string) {
  if (string == null) {
    return "";
  }
  if (isSafeString(string)) {
    return string.toHtml();
  }
  return escapeTextForBrowser_default(string);
}
var withInterpolationEscape = (payload) => ({
  ...payload,
  interpolation: {
    escape,
    escapeValue: true,
    useRawValueToEscape: true
  }
});
var TAG_NAME_ALLOWED = ["div", "span", "p", "h1", "h2", "h3", "h4", "h5", "h6", "strong", "ul", "ol", "li"];
var Trans = ({
  tagName: TagName = TAG_NAME_ALLOWED[0],
  i18nKey,
  className,
  ...payload
}) => {
  const { t } = useI18nContext();
  const translation = t(i18nKey, withInterpolationEscape(payload));
  return /* @__PURE__ */ React2.createElement(TagName, { className, dangerouslySetInnerHTML: { __html: translation } });
};
Trans.safeString = (value) => new SafeString(value);
var Trans_default = Trans;
export {
  I18nContextProvider,
  Trans_default as Trans,
  i18n_default as i18n,
  nestedLinksParserPlugin,
  useI18nContext
};
//# sourceMappingURL=index.mjs.map